<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Blogs</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a></li>
                            <li class="breadcrumb-item active">Blogs</li>
                        </ol>
                    </div>
                </div>
            </div>
            <div class="content-header-right col-md-6 col-12 mb-md-0 mb-2">
                <Link :href="route('admin.blogs.create')" class="btn btn-outline-primary float-md-right">
                    <i class="feather icon-plus icon-left"></i>
                    Add Blog
                </Link>
            </div>
        </div>

        <div class="content-body">
            <section class="card">
                <div class="card-header">
                    <h4>Blogs</h4>
                </div>
                <div class="card-body">
                    <vue-good-table
                        class="dataTable"
                        mode="remote"
                        :isLoading.sync="tableDataLoading"
                        :totalRows="totalRecords"
                        :pagination-options="paginationOptions"
                        :sort-options="sortingOptions"
                        @on-page-change="this.onPageChange"
                        @on-per-page-change="this.onPerPageChange"
                        styleClass="vgt-table"
                        :columns="columns"
                        :rows="allBlogs"
                    >
                        <div slot="emptystate" class="loading-container">
                            <img src="/images/Spinner.svg" alt="">
                        </div>
                        <template slot="table-row" slot-scope="props">
                            <span v-if="props.column.field === 'sn'">
                                {{ serialNo(props) }}
                            </span>
                            <span v-else-if="props.column.field === 'cover_image'">
                                <img v-if="props.row.cover_image" :src="props.row.cover_image" alt="" style="max-width: 90px; height: auto;">
                            </span>
                            <span v-else-if="props.column.field === 'category'">
                                {{ props.row.category ? props.row.category.name : '' }}
                            </span>
                            <span v-else-if="props.column.field === 'published_at'">
                                {{ formatDate(props.row.published_at) }}
                            </span>
                            <div v-else-if="props.column.field === 'featured'">
                                <span class="badge badge-glow" :class="props.row.featured_at ? 'badge-success' : 'badge-secondary'">
                                    {{ props.row.featured_at ? 'Featured' : 'No' }}
                                </span>
                            </div>
                            <div v-else-if="props.column.field === 'status'">
                                <span class="badge badge-glow" :class="props.row.status ? 'badge-success' : 'badge-danger'">
                                    {{ props.row.status ? 'Active' : 'Inactive' }}
                                </span>
                            </div>
                            <table-row-actions v-else-if="props.column.field === 'action'">
                                <a href="#" class="dropdown-item" @click.prevent="featureBlog(props.row.id)">
                                    {{ props.row.featured_at ? 'Unfeature' : 'Feature' }}
                                </a>
                                <Link :href="route('admin.blogs.edit', props.row.id)" class="dropdown-item">
                                    <i class="feather icon-edit"></i>
                                    Edit
                                </Link>
                                <a href="#" @click.prevent="showAlert(props.row.id)" class="dropdown-item text-danger">
                                    <i class="feather icon-trash-2"></i>
                                    Delete
                                </a>
                            </table-row-actions>
                        </template>
                    </vue-good-table>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import {Link} from '@inertiajs/vue2'
import DeleteAlert from "../../Shared/Mixins/DeleteAlert";
import PaginationMixin from "../../Shared/Mixins/PaginationMixin";

export default {
    metaInfo: {title: 'Blogs'},
    props: ['blogs'],
    layout: Layout,
    components: { Link },
    mixins: [DeleteAlert, PaginationMixin],
    data: () => ({
        allBlogs: [],
        totalRecords: 0,
        serverParams: {
            page: 1,
            perPage: 10
        },
        paginationOptions: {
            enabled: true,
            mode: 'pages',
            perPage: 10,
            perPageDropdown: [5, 10, 20, 50, 100, 200],
            dropdownAllowAll: false,
        },
        sortingOptions: {
            enabled: false,
        },
        columns: [
            {label: 'S/N', field: 'sn'},
            {label: 'Cover', field: 'cover_image', sortable: false},
            {label: 'Title', field: 'title'},
            {label: 'Category', field: 'category'},
            {label: 'Author', field: 'author_name'},
            {label: 'Published', field: 'published_at'},
            {label: 'Featured', field: 'featured'},
            {label: 'Status', field: 'status'},
            {label: 'Action', field: 'action', sortable: false},
        ],
        tableDataLoading: false,
    }),
    mounted() {
        this.allBlogs = this.blogs.data;
        this.totalRecords = this.blogs.total;
    },
    methods: {
        formatDate(value) {
            if (!value) {
                return '';
            }
            return String(value).substring(0, 10);
        },
        async paginatedData() {
            try {
                const response = await axios.get(route('admin.blogs.index'), {
                    params: {
                        page: this.serverParams.page,
                        per_page: this.serverParams.perPage,
                        api: true
                    },
                    headers: {
                        "X-Requested-With": "XMLHttpRequest",
                    },
                });
                this.totalRecords = response.data.total;
                this.paginationOptions.perPage = response.data.per_page;
                this.serverParams.perPage = response.data.per_page;
                this.allBlogs = response.data.data;
            } catch (e) {
                console.log(e);
            }
        },
        async featureBlog(id) {
            this.$inertia.post(route('admin.blogs.feature', id), {}, {
                preserveScroll: true,
                onSuccess: () => this.paginatedData()
            });
        },
        async deleteBlog(id) {
            this.$inertia.delete(route('admin.blogs.delete', id), {
                preserveScroll: true,
                onSuccess: () => this.paginatedData()
            });
        },
        async showAlert(blogId) {
            const details = {
                title: "Are you sure you want to delete this blog?",
                text: "You won't be able to revert this!",
            };
            await this.deleteAlert(details.title, details.text) ? await this.deleteBlog(blogId) : "";
        },
    }
}
</script>
